module.exports = __webpack_public_path__ + "static/media/bag.e44fe149.svg";